import styled from "styled-components";
import { Checkbox } from "antd";

export const CheckboxGroup = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: flex-start;
  margin: 0px 0px 8px;
  line-height: 2em;
`;

export const CustomCheckbox = styled(Checkbox)`
  margin-bottom: 6px;
  margin-top: 6px;

  &.ant-checkbox-wrapper + .ant-checkbox-wrapper {
    margin: 0;
  }
  &.ant-checkbox-wrapper {
    display: flex;
  }
  & .ant-checkbox {
    margin-top: 0px;
    margin-right: 8px;
    width: 22px;
    height: 22px;
  }
  & .ant-checkbox-inner {
  }
  & .ant-checkbox .ant-checkbox-input + .ant-checkbox-inner {
    width: 22px;
    height: 22px;
  }
  & .ant-checkbox-checked::after {
    border: 0px;
    border: 2px solid #1070b6;
    background: #7ea7d4;
  }
  & .ant-checkbox-inner::after {
    left: 30%;
  }
  & span {
    padding: 0px;
  }
  & span:not(.ant-checkbox) {
    font-size: 16px;
  }
`;
